import { Network } from ':fat/core/networks';
import { Xpub } from ':fat/database/schema-types';
import { ScanningProgress, Transaction } from ':fat/workers/blockchain/types';

// These messages are the ones that can be sent to the main page
export type Message =
  | { kind: 'READY' }
  | { kind: 'PING' }
  | { kind: 'PONG' }
  | { kind: 'SANITY_CHECK_RESPONSE'; success: boolean; error?: string }
  | { kind: 'QUERY_RESULT'; result: unknown }
  | { kind: 'QUERY_ERROR'; error: string }
  | { kind: 'GO_TO_LANDING' }
  | { kind: 'ENTERED_SEED_PHRASE'; xpubs: Record<Network, Xpub> }
  | { kind: 'SCANNING_PROGRESS'; progress?: ScanningProgress }
  | { kind: 'CONSTRUCTED_TRANSACTIONS'; txs: Record<Network, Transaction[]> }
  | { kind: 'SIGNED_TRANSACTIONS'; signedTxs: Record<Network, Transaction[]> }
  | { kind: 'SIGNING_ERROR'; error: string }
  | { kind: 'CONSTRUCT_TRANSACTION_ERROR'; error: string }
  | { kind: 'NO_SIGNER' };

export async function ping() {
  return MessageBus.send('mainPage', { kind: 'PING' }, { expectReply: 'PONG' });
}

export async function enteredSeedPhrase(xpubs: Record<Network, Xpub>) {
  return MessageBus.send(
    'mainPage',
    { kind: 'ENTERED_SEED_PHRASE', xpubs },
    { expectReply: 'XPUBS_SAVED' },
  );
}

export async function goToLandingPage() {
  return MessageBus.send('mainPage', { kind: 'GO_TO_LANDING' });
}
